import React, { useEffect, useState, Fragment } from 'react';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import './index.less';

const VerticalTable = props => {
  const { dataSource, searchHook } = props;
  const [tableDom, setTableDom] = useState();

  const getClassName = (className, depth) => {
    let resultClass = className + ' my-tr' + depth;

    if (className === 'ant-col-3') {
      resultClass += '-left';
    } else if (className === 'ant-col-21') {
      resultClass += '-right';
    }
    return resultClass;
  };

  const getTr = (item, depth) => {
    let tr = null;
    let dep = depth;

    dep++;
    if (dep === 4) {
      if (item.status === 0) {
        return (
          <Fragment>
            <CloseOutlined />
          </Fragment>
        );
      }
      return (
        <Fragment>
          <CheckOutlined />
          <pre>{JSON.stringify(item, null, 2)}</pre>
        </Fragment>
      );
    }
    Object.keys(item).forEach(function (s_index) {
      tr = (
        <Fragment>
          {tr}
          <div className={getClassName('ant-row', dep)}>
            <div className={getClassName('ant-col-3', dep)}>{dep === 1 ? <pre>{s_index}</pre> : s_index}</div>
            <div className={getClassName('ant-col-21', dep)}>{getTr(item[s_index], dep)}</div>
          </div>
        </Fragment>
      );
    });
    return tr;
  };

  useEffect(() => {
    console.log(searchHook);
    let msg = searchHook === -1 ? '' : '正在查询...';
    const table = dataSource ? <div className="my-table">{getTr(dataSource, 0)}</div> : msg;

    setTableDom(table);
  }, [dataSource, searchHook]);

  return <Fragment>{tableDom}</Fragment>;
};

export default VerticalTable;
